import React from "react";

import Link from "core/Link";

import { useLoginFlow } from "../Context";

const DefaultViewLink = ({ children }) => {
    const { goToDefaultView } = useLoginFlow();

    return (
        <Link
            isButton
            onClick={e => {
                e.preventDefault();
                goToDefaultView();
            }}
            data-testid="default-view-link"
        >
            {children}
        </Link>
    );
};

export default DefaultViewLink;
